// 002/003 pasaron de Questionnaire a formulario discreto (Fase 7, Tanda 17). Las anamnesis ya guardadas como
// `QuestionnaireResponse` siguen enlazadas desde Notas/Historia con `?respuestaId=...`: la ruta discreta ignora ese
// parámetro, así que aquí se deriva al visor del motor de Questionnaire (que sí sabe leer y editar la respuesta vieja).
// Sin `respuestaId` (formulario nuevo) se muestra el formulario discreto.
import type { JSX } from 'react';
import { useSearchParams } from 'react-router';
import { FormularioDiscretoPage } from './FormularioDiscretoPage';
import { MotorFormularioPage } from './MotorFormularioPage';

export function FormularioConHistorico({ codigo }: { readonly codigo: string }): JSX.Element {
  const [searchParams] = useSearchParams();
  return searchParams.get('respuestaId') ? <MotorFormularioPage codigoFijo={codigo} /> : <FormularioDiscretoPage codigo={codigo} />;
}
